module.exports = __webpack_public_path__ + "static/media/icon-large-watch.33cb0614.svg";